<template>
	<div id="patient-container" class="screen">
		<div class="screen-container">
			<NavAmlCll
				v-bind:si="'aml'"
			/>
			<div class="wrapper flex">
				<div class="container">
					<header class="flex">
						<img width="95" height="106" src="@/assets/neutropenia/top_left_icon.png" class="top-left-icon">
						<div class="header-content">
							<h1>Neutropenia Management Center</h1>
							<div class="question-container flex" v-bind:class="finalStep ? 'final-step' : ''">
								<img 
									v-for="(step, index) in 4" 
									v-bind:key="index" 
									v-bind:src="require(`@/assets/neutropenia/number_${step}.png`)"
									class="number"
									v-bind:class="['number-' + step, step == activeNumber ? 'show': '']"
								>
								<div class="question flex">
									<div class="copy" v-html="steps[current_copy].header_copy"></div>
									<div class="yes-no-refresh flex">
										<div v-on:click="yesNoRefresh('yes')" class="container flex yes"
											v-bind:class="{'grey': greyYes}"
										>
											<div>YES</div>
										</div>
										<div v-on:click="yesNoRefresh('no')" class="container flex no"
											v-bind:class="{'grey': greyNo}"
										>
											<div>NO</div>
										</div>
										<div v-on:click="yesNoRefresh('refresh')" class="container flex refresh">
											<img src="@/assets/neutropenia/refresh.png" class="refresh">
										</div>
									</div>
								</div>
							</div>
						</div>
					</header>
					<div class="content">
						<img 
							v-for="(step,stepKey) in this.steps" 
							v-bind:key="stepKey" 
							v-bind:src="require(`@/assets/neutropenia/${stepKey}.png`)" 
							class="slide" 
							v-bind:class="[stepKey,step.isActive ? 'show': '']"/>

						<div class="supporting-data-popup"
							v-bind:class="{'show': supportingDataIsOpen}"
						>
							<img src="@/assets/neutropenia/supporting_data_popup.png">
						</div>
						<div v-on:click="viewSupportingDataOpen" class="view-supporting-data view-supporting-data-open">
							<img src="@/assets/neutropenia/view_supporting_data.png">
						</div>
						<div v-on:click="viewSupportingDataOpen" class="view-supporting-data view-supporting-data-close"
							v-bind:class="{'show': supportingDataIsOpen}"
						>
							<img src="@/assets/neutropenia/view_supporting_data_close.png">
						</div>
					</div>
					<footer class="flex">
						<img src="@/assets/neutropenia/footer_text.png" class="footer-text">
						<img src="@/assets/neutropenia/footer_logo.png" class="footer-logo">
					</footer>
				</div>
			</div>

		</div>
	</div>
</template>
<script>
import NavAmlCll from '@/components/NavAmlCll'

export default {
	components: {
		NavAmlCll
	},
	data() {
		return {
			activeNumber: 1,
			steps: {
				p2: {
					"yes": "p4",
					"no": "p3",
					"grey_yes": false,
					"grey_no": false,
					"number": 1,
					"header_copy": "Has the patient experiencing Grade 4 neutropenia<br>or thrombocytopenia achieved remission (&lt;5% blasts)?",
					"isActive": true
				},
				p3: {
					"grey_yes": true,
					"grey_no": true,
					"number": 1,
					"header_copy": "Has the patient experiencing Grade 4 neutropenia<br>or thrombocytopenia achieved remission (&lt;5% blasts)?",
					"isActive": false
				},
				p4: {
					"yes": "p5",
					"no": "p6",
					"grey_yes": false,
					"grey_no": false,
					"number": 2,
					"header_copy": "Is this the cycle in which blast clearance was achieved?",
					"isActive": false
				},
				p5: {
					"grey_yes": true,
					"grey_no": true,
					"number": 2,
					"header_copy": "Is this the cycle in which blast clearance was achieved?",
					"isActive": false
				},
				p6: {
					"yes": "p7",
					"no": "p8",
					"grey_yes": false,
					"grey_no": false,
					"number": 3,
					"header_copy": "Is this the first occurrence of Grade 4 neutropenia or thrombocytopenia<br>after achieving remission and lasting at least 7 days?",
					"isActive": false
				},
				p7: {
					"grey_yes": true,
					"grey_no": true,
					"number": 3,
					"header_copy": "Is this the first occurrence of Grade 4 neutropenia or thrombocytopenia<br>after achieving remission and lasting at least 7 days?",
					"isActive": false
				},		
				p8: {
					"yes": "p9",
					"grey_yes": false,
					"grey_no": true,
					"number": 4,
					"header_copy": "Is this a subsequent Grade 4 neutropenia or<br>thrombocytopenia lasting at least 7 days?",
					"isActive": false
				},	
				p9: {
					"grey_yes": true,
					"grey_no": true,
					"number": 4,
					"header_copy": "Is this a subsequent Grade 4 neutropenia or<br>thrombocytopenia lasting at least 7 days?",
					"isActive": false
				}
			},
			current_copy: 'p2',
			supportingDataIsOpen: false,
			greyYes: false,
			greyNo: false,
			next_slide: null,
			current_position: "p2",
			current_position_data: null,
			next_position_data: null,
			next_number: null
		}
	},
	watch: {
		current_position: function(val){
			if(val === 'p9'){
				this.finalStep = true
			} else {
				this.finalStep = false
			}
		}
	},
	methods: {
		viewSupportingDataOpen(){
			this.supportingDataIsOpen = !this.supportingDataIsOpen
		},
		process(answer){

			this.current_position_data = this.steps[this.current_position]

			if(answer === "refresh") {

				this.next_slide = "p2"
				this.greyYes = false
				this.greyNo = false
				this.next_position_data = this.steps[this.next_slide]
				this.next_number = this.next_position_data["number"]
				this.next_copy = this.next_slide

			} else {
				this.current_position_data = this.steps[this.current_position]
				this.next_slide = this.current_position_data[answer];
				this.next_position_data = this.steps[this.next_slide];
				this.next_number = this.next_position_data["number"];
				this.next_copy = this.next_slide

				if(this.next_position_data['grey_yes'] == true) {
					this.greyYes = true
				}

				if(this.next_position_data['grey_no'] == true) {
					this.greyNo = true
				}
			}

			this.steps[this.current_position].isActive = false
			this.steps[this.next_slide].isActive = true
			this.activeNumber = this.next_number
			this.current_copy = this.next_copy
			this.current_position = this.next_slide;
		},
		yesNoRefresh(val){
			switch(val){
				case "yes":
					if(!this.greyYes){
						this.process(val)
					}
				break;

				case "no":
					if(!this.greyNo){
						this.process(val)
					}
				break;

				case "refresh":
					this.process(val)
				break;
			}
		}
	}
}
</script>
<style scoped>
.flex {
	display: flex;
}

.flex-column {
	flex-direction: column;
	font-family: Arial;
}

.flex-align-items-center {
	align-items: center;
}

.flex-wrap {
	flex-wrap: wrap;
}

.flex-full {
	flex: 1;
}

body {
	background-color: #ecedf1;
	min-height: 100vh;
	font-family: Arial;
}

.wrapper {
	align-items: center;
	justify-content: center;
}

.wrapper > .container {
	width: 1024px;
	height: 768px;
	padding-top: 87px;
}

h1 {
	color: #27b4a3;
	font-size: 2.23rem;
	font-weight: bold;
	letter-spacing: 0.7px;
	margin-left: 4px;
	margin-bottom: 11px;
}

header,
.content {
	padding: 0 39px;
}

header {
	margin-bottom: 20px;
}

.header-content {
	margin-top: 12px;
	flex: 1;
}

.header-content .number {
	width: 43px;
	z-index: 2;
	display: none;
}

.header-content .number.show {
	display: block;
}

.content {
	position: relative;
	min-height: 505.27px;
}

.content .supporting-data-popup {
	position: absolute;
	right: 39px;
	bottom: -2px;
	z-index: 1;
	display: none;
}

.content .supporting-data-popup.show {
	display: block;
	animation-name: fadein;
	animation-duration: .4s;	
	-webkit-animation-name: fadein;
	-webkit-animation-duration: .4s;
}

.content .supporting-data-popup img {
	width: 352px;
}

.final-step > img,
.final-step .copy {
	opacity: .39
}

/* Standard syntax */
@keyframes fadein {
	0% {display:none; opacity: 0;}
	1% {display: block; opacity: 0;}
	100% {display: block; opacity: 1;}
}

@-webkit-keyframes fadein {
	0% {display:none; opacity: 0;}
	1% {display: block; opacity: 0;}
	100% {display: block; opacity: 1;}
}

.content .view-supporting-data {
	position: absolute;
	right: 39px;
	bottom: -7px;
	cursor: pointer;
	z-index: 2;
}

.content .view-supporting-data-close {
	z-index: 3;
	display: none;
}

.content .view-supporting-data-close.show {
	display: block;
}

.content .view-supporting-data img {
	width: 223px;
}


.content .slide {
	width: 100%;
	display: none;
}

.content .slide.show {
	display: block;
}

.top-left-icon {
	width: 95px;
	margin-right: 27px;
}

.question-container .question {
	background-color: #dee1e8;
	width: calc(100% + 20px);
	margin-left: -20px;
	align-items: center;
	position: relative;
}

.question-container .question .copy {
	margin-left: 31px;
	font-size: 1.65rem;
	font-weight: 500;
	letter-spacing: 0.4px;
	line-height: 1.15;
}

.yes-no-refresh {
	background-image: url(../assets/neutropenia/yes_no_refresh.png);
	background-size: cover;
	width: 207px;
	height: 64px;
	position: absolute;
	top: -8px;
	right: -5px;
	color: #211847;
	font-size: 1.8rem;
	font-weight: bold;
	align-items: center;
}

.yes-no-refresh .refresh {
	width: 26px;
}

.yes-no-refresh .container {
	flex: 1;
	text-align: center;
	margin-top: 4px;
	height: 40px;
	border-right: 1px solid #cfcfdb;
	justify-content: center;
	align-items: center;
	cursor: pointer;
}

.yes-no-refresh .container.grey {
	color: #cccccc;
	cursor: unset;
}

.yes-no-refresh .container:last-child {
	border-right: none;
}

footer {
	align-items: flex-end;
}

footer .footer-text {
	width: 946px;
	margin-top: 6px;
	margin-left: 40px;
}

footer .footer-logo {
	width: 81px;
	margin-left: -60px;
}
</style>